import {
  fetchAuthUser,
  setLanguage,
  setAuthToken,
  setAuth,
  setExpiresIn,
  setTokenCreatedAt
} from "Actions";
import { getTTPUser } from "Api";

import * as actions from "Actions";
import * as api from "Api";

import { APP_ENV } from "Config";

import {
  getAuthInfosFromCookie,
  authHasExpired,
  setLocalStorageAuth,
  redirectToHome,
  setCookie,
  clearAllCookies
} from "Utils";

export const setAuthUser = user => {
  return (dispatch, getState) => {
    dispatch(setAuthToken(user.token));
    dispatch(setExpiresIn(user.expiresIn));
    dispatch(setTokenCreatedAt(user.createdAt));
    dispatch(
      fetchAuthUser(
        getTTPUser({ userId: user.id, token: user.token }).then(res => {
          const user = res.data.data[0];
          const lng = localStorage.getItem("lng");
          if (!lng || lng.length === 0) {
            dispatch(setLanguage(user.language));
          }
          return user;
        }, err => err)
      )
    );
  };
};

export const login = () => {
  return (dispatch, getState) => {
    let authInfos = getAuthInfosFromCookie();

    if (!authInfos || authHasExpired(authInfos)) {
      setLocalStorageAuth(null);
      clearAllCookies(redirectToHome);
    }

    // const auth = getLocalStorageAuth();
    const auth = null;

    if (auth && auth.user && authInfos.token === auth.token) {
      dispatch(setAuth(auth));

      const lng = localStorage.getItem("lng");
      if (!lng || lng.length === 0) {
        dispatch(setLanguage(auth.user.language));
      }
    } else {
      dispatch(setAuthUser(authInfos));
    }
  };
};

export const setCurrentOrganization = organization => (dispatch, getState) => {
  const { token } = getState().auth;

  return dispatch(
    actions.setCurrentOrganization(
      api.setCurrentOrganization(token, organization).then(() => {
        let data = {
          id: organization.id,
          abbreviation: organization.abbreviation | "",
          name: organization.name,
          avatarUrl: organization.avatarUrl
        };
        const dtExpire = new Date();
        dtExpire.setTime(dtExpire.getTime() + 86400 * 1000 * 3); //3j
        setCookie(
          `ttp_community_${APP_ENV}`,
          JSON.stringify(data),
          dtExpire,
          "/",
          "tamtam.pro"
        );
        return organization;
      }, err => err)
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/auth.js